import directSettings from "fantastic/lib/directSettings";

class DeterminateThumbnail {
  constructor(url, callback, fail) {
    this.url = url;
    this.determinate(callback, fail);
  }

  determinate(callback, fail) {
    return ( async () => {
      return await this.get(this.requestUrl());
    })().then(callback, fail);
  }

  requestUrl(){
    const { upload_thumbnail } = directSettings();
    return `${upload_thumbnail}?url=${encodeURIComponent(this.url.trim())}`
  }

  get(url) {
    return new Promise((resolve, reject) => {
      const request = new XMLHttpRequest();

      request.open('GET', url);
      request.onload = () => {
        if(request.status == 200) {
          try {
            const response = JSON.parse(request.response);
            if(response.result == 'fail'){
              reject(response.messages);
            }
            else {
              resolve(response);
            }
          } catch (e) {
            reject();
          }
        }
        else {
          reject();
        }
      }

      request.onerror = () => reject();
      request.send();
    });
  }
}

export default DeterminateThumbnail;
